export enum TreeSearchDisplayMode {
  List,
  Tree,
}
